import React, {Dispatch, SetStateAction} from 'react';
import {
  Select as MuiSelect,
  MenuItem,
  InputLabel,
  FormControl,
  Chip,
  SelectChangeEvent,
  Typography, Checkbox, Stack,
} from '@mui/material';
import ChevronDownIcon from "assets/icons/ChevronDown";
import DeleteIcon from "assets/icons/Delete";
import Grid from "@mui/material/Grid2";

interface CustomSelectProps {
  label: string;
  options: { id: string; title: string }[];
  selectedTags: string[];
  setSelectedTags: Dispatch<SetStateAction<string[]>>;
}

const MultipleSelect: React.FC<CustomSelectProps> = ({label, options, selectedTags, setSelectedTags}) => {

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    setSelectedTags(event.target.value as string[]);
  };

  const handleDelete = (deleteValue: string) => {
    setSelectedTags(prevState => prevState.filter(tag => tag !== deleteValue));
  }

  return (
    <Stack spacing={2.5}>
      <FormControl variant="outlined">
        <InputLabel shrink sx={{top: 8, left: 12}}>{label}</InputLabel>
        <MuiSelect
          multiple
          disableUnderline
          displayEmpty
          variant={'filled'}
          value={selectedTags}
          onChange={handleChange}
          label={label}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 290,
                maxWidth: 400,
                overflowY: "auto",
              },
            },
          }}
          IconComponent={ChevronDownIcon}
          renderValue={(selected) => (
            <Typography variant={'p2'} sx={{
              '& > span': {
                color: 'primary.main',
                fontWeight: 500
              }
            }}>
              Выбрано: <span>({(selected as string[]).length})</span>
            </Typography>
          )}
        >
          {options.map((option) => (
              <MenuItem
                  key={option.id}
                  value={option.id}
                  sx={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    maxWidth: '100%',
                  }}
              >
                <Checkbox checked={selectedTags.includes(option.id)}/>
                <Typography
                    variant={'p2'}
                    sx={{
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      flex: 1,
                    }}
                >
                  {option.title}
                </Typography>
              </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>
      {selectedTags.length > 0 && (
        <Stack spacing={1.5} >
          <Typography variant={'p3'} sx={{color: 'grey.200'}}>Выбранные теги</Typography>
          <Grid container spacing={1} >
            {selectedTags.map((tagValue) => {
              const tag = options.find((option) => option.id === tagValue);
              return (
                  <Grid key={tagValue}>
                    <Chip
                        onDelete={() => handleDelete(tagValue)}
                        sx={{
                          width: 'max-content',
                          height: 'auto',
                          '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            textAlign: 'left',
                            padding: '8px 12px',
                          }
                        }}
                        deleteIcon={<DeleteIcon sx={{color: 'white'}} />}
                        label={tag?.title || tagValue}/>
                  </Grid>
                )
            })}
          </Grid>
        </Stack>
      )}
    </Stack>
  );
};

export default MultipleSelect;
